var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from "lodash";
import { useCallback, useEffect, useLayoutEffect, useRef, useState, } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import CommonLtpRenderer from "src/components/ltp-renderer/common-ltp-renderer";
import { setRefreshGlobalCalled } from "src/redux/reducers/common-reducer";
import { SESSION_KEYS, getDataFromSession } from "src/utils/session-storage";
import { getIndicesMasterV3, setMasterIndices, } from "../../apis/dashboard";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { openChartTab, splitAndGetDetailsFromLongName, } from "../../utils/methods";
import { setDataInSession } from "../../utils/session-storage";
import Shimmer from "../loader/shimmer";
import styles from "./navbarOne.module.scss";
import { v4 as uuid } from "uuid";
import { stockInfoData } from "src/redux/reducers/stock-info-Reducer";
import { useNavigate } from "react-router";
import { createSearchParams } from "react-router-dom";
import { getIndicesDummyData } from "src/apis/mock/data/get-indices";
const componentName = "IndicesBar";
// const socketObservable = new Subject<OpenFeedSocketRespType>();
const IndicesBar = () => {
    // const [isSocketSubRequired, setSocketSubRequired] = useState(false);
    const refreshGlobalCalled = useAppSelector((state) => state.commonReducer.refreshGlobalCalled);
    const [indexData, setIndexData] = useState([]);
    const [indicesMaster, setIndicesMaster] = useState([]);
    const [indiceCheckedList, setIndiceCheckedList] = useState([]);
    const [showIndicesDD, setShowIndicesDD] = useState(false);
    const indiceMapRef = useRef({});
    const dispatch = useAppDispatch();
    const searchUIDRef = useRef(uuid());
    let count = 0;
    const onDDarrowClick = () => {
        getIndicesMaster(indexData);
        setShowIndicesDD((showIndicesDD) => !showIndicesDD);
    };
    const getIndexData = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
            if (clientCode) {
                let listOfIndices = getDataFromSession(SESSION_KEYS.LISTOFINDICES) || [];
                if (listOfIndices.length > 0) {
                    listOfIndices = listOfIndices.includes(null) ? [] : listOfIndices;
                }
                // if (listOfIndices.length == 0) {
                // const response = await getIndices(clientCode);
                // Productio API
                // const response = await dashboardWorkerRef.getIndicesImpl(
                //   clientCode,
                //   searchUIDRef.current
                // );
                // Dummy response
                const response = { data: getIndicesDummyData() };
                let updatedList = response.data.body.lstofindices;
                updatedList = updatedList.map((index) => {
                    if (index.IndexName == "Nifty 50") {
                        index.IndexName = "Nifty";
                    }
                    return index;
                });
                if (updatedList.length > 0) {
                    setDataInSession(SESSION_KEYS.LISTOFINDICES, updatedList);
                    setIndexData(updatedList);
                }
                else {
                    setIndexData(listOfIndices);
                }
                // const response = { data: getIndicesDummyData() };
            }
            else {
                const response = { data: getIndicesDummyData() };
                let updatedList = response.data.body.lstofindices;
                updatedList = updatedList.map((index) => {
                    if (index.IndexName == "Nifty 50") {
                        index.IndexName = "Nifty";
                    }
                    return index;
                });
                if (updatedList.length > 0) {
                    setDataInSession(SESSION_KEYS.LISTOFINDICES, updatedList);
                    setIndexData(updatedList);
                }
            }
        }
        catch (err) {
            setDataInSession(SESSION_KEYS.LISTOFINDICES, [], true);
            if (count <= 1) {
                count++;
                getIndexData();
            }
        }
    }), []);
    useEffect(() => {
        if (refreshGlobalCalled) {
            const updatedIndice = indexData.map((item) => {
                const ltpData = indiceMapRef.current[item.ScripCode];
                if (ltpData) {
                    return Object.assign(Object.assign({}, item), { ltp: indiceMapRef.current[item.ScripCode].ltp, prevClose: indiceMapRef.current[item.ScripCode].prevClose });
                }
            });
            setDataInSession(SESSION_KEYS.LISTOFINDICES, updatedIndice, true);
            dispatch(setRefreshGlobalCalled(false));
        }
        // setIndexData(indexData); --
    }, [refreshGlobalCalled]);
    // Code for handling outside click for search model opening
    useLayoutEffect(() => {
        getIndexData();
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    }, []);
    const getIndicesMaster = (indicesList) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // let mainIndices: IndicesType[] = [];
            let mainIndices = [];
            if (indicesMaster.length === 0) {
                const exchangeList = ["N", "B"];
                const promises = [];
                // const resp = await getIndicesMasterNew();
                exchangeList.map((exch) => {
                    promises.push(getIndicesMasterV3(exch));
                });
                const [resp1, resp2] = yield Promise.all(promises);
                const resp = [...resp1.data.IndiceData, ...resp2.data.IndiceData];
                mainIndices = resp;
            }
            else {
                mainIndices = indicesMaster;
            }
            for (const masterIndice of mainIndices) {
                const isMatch = indicesList.find((indice) => Number(indice.ScripCode) === masterIndice.IndiceID);
                if (isMatch) {
                    masterIndice.checkbox = true;
                    masterIndice.disabled = false;
                }
                else {
                    masterIndice.checkbox = false;
                    masterIndice.disabled = true;
                }
            }
            const checkedIndices = mainIndices.filter((item) => item.checkbox === true);
            setIndicesMaster(mainIndices);
            setIndiceCheckedList(checkedIndices);
        }
        catch (err) {
            console.error(err);
        }
    });
    const updateIndexData = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
            if (clientCode) {
                // const response = await getIndices(clientCode);
                const response = { data: getIndicesDummyData() };
                // const response = await dashboardWorkerRef.getIndicesImpl(
                //   clientCode,
                //   searchUIDRef.current
                // );
                let updatedList = response.data.body.lstofindices;
                updatedList = updatedList.map((index) => {
                    if (index.IndexName == "Nifty 50") {
                        index.IndexName = "Nifty";
                    }
                    return index;
                });
                setDataInSession(SESSION_KEYS.LISTOFINDICES, updatedList, true);
                setIndexData(updatedList);
            }
            else {
                setIndexData(indexData);
            }
        }
        catch (err) {
            console.error(err);
        }
    });
    const renderIndexData = () => {
        return (_jsxs(_Fragment, { children: [indexData.length == 0 ? (_jsx(Shimmer, {})) : (indexData.map((singleData, i) => {
                    return renderSinlgeIndexData(singleData);
                })), renderMasterIndices()] }));
    };
    const renderMasterIndices = () => (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: `${styles.customIndicesDropdownWrapper}` }, { children: [_jsx("span", { className: styles.verticalBorder }), showIndicesDD && (_jsx(OutsideClickHandler, Object.assign({ onOutsideClick: () => {
                        setShowIndicesDD(false);
                    } }, { children: _jsxs("div", Object.assign({ className: `${styles.customIndicesDropdown}` }, { children: [_jsx("div", Object.assign({ className: `${styles.customIndicesDropdownScroll}` }, { children: indicesMaster.length == 0 ? (_jsx(Shimmer, {})) : (indicesMaster.map((singleElement, key) => renderSingleIndex(singleElement, key))) })), _jsxs("div", Object.assign({ className: "buttonWrapper buttonWrapperSmall indices-buttonwrap" }, { children: [_jsx("button", Object.assign({ onClick: () => {
                                            setShowIndicesDD(false);
                                        }, type: "submit", className: "btnType2 me-3", style: { minWidth: "85px" } }, { children: "Cancel" })), _jsx("button", Object.assign({ onClick: () => handleApplyIndices(), type: "submit", className: "btnType1", disabled: indiceCheckedList.length !== 2, style: { minWidth: "85px" } }, { children: "Apply" }))] }))] })) })))] })) }));
    const navigate = useNavigate();
    const stockInfoPage = (singleScript, priceData) => {
        const data = {
            symbol: singleScript === null || singleScript === void 0 ? void 0 : singleScript.IndexName,
            exchange: singleScript === null || singleScript === void 0 ? void 0 : singleScript.Exch,
            exchangeType: singleScript === null || singleScript === void 0 ? void 0 : singleScript.ExchType,
            scripCode: (singleScript === null || singleScript === void 0 ? void 0 : singleScript.IndiceID)
                ? singleScript === null || singleScript === void 0 ? void 0 : singleScript.IndiceID
                : singleScript === null || singleScript === void 0 ? void 0 : singleScript.ScripCode,
            lastTradePrice: singleScript === null || singleScript === void 0 ? void 0 : singleScript.IndexValue,
            previousClose: singleScript === null || singleScript === void 0 ? void 0 : singleScript.ClosingIndex,
            expiry: "",
            StrikeRate: "",
            indexId: "1",
        };
        const params = data;
        setShowIndicesDD(false);
        navigate({
            pathname: "/stock-info",
            search: `?${createSearchParams(params)}`,
        });
        dispatch(stockInfoData(params));
    };
    const renderSingleIndex = (singleElement, key) => (_jsxs("div", Object.assign({ className: `${styles.customIndicesRow}` }, { children: [_jsxs("div", Object.assign({ className: "d-flex align-items-center" }, { children: [_jsxs("label", Object.assign({ className: "customCheckbox" }, { children: [_jsx("input", { type: "checkbox", disabled: singleElement.disabled, checked: singleElement === null || singleElement === void 0 ? void 0 : singleElement.checkbox, onChange: (e) => handleCheckboxChange(e.target.checked, key) }), _jsx("span", { className: "checkmark" })] })), _jsx("span", Object.assign({ className: `${styles.indexName} medium text-uppercase`, title: `${singleElement === null || singleElement === void 0 ? void 0 : singleElement.IndexName}`, onDoubleClick: () => stockInfoPage(singleElement, singleElement === null || singleElement === void 0 ? void 0 : singleElement.priceData) }, { children: singleElement === null || singleElement === void 0 ? void 0 : singleElement.IndexName }))] })), _jsx(CommonLtpRenderer, { scripCode: singleElement.IndiceID, exch: singleElement.Exch, exchType: singleElement.ExchType, renderElement: (ltp, prevClose, changePercentObj) => {
                    return commonLtpRenderIndexCallBack(singleElement.IndiceID, ltp, prevClose, changePercentObj);
                }, componentName: "IndicesMaster" })] }), key));
    const commonLtpRenderIndexCallBack = useCallback((scripCode, ltp, prevClose, changePercentObj) => {
        if (isEmpty(ltp)) {
            return _jsx(_Fragment, {});
        }
        return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "d-flex align-items-center" }, { children: [_jsx("span", { children: ltp }), _jsxs("span", Object.assign({ className: `${styles.ltpChangeValue} small ms-1 ${changePercentObj.isNegative ? "negativeText" : "positiveText"}` }, { children: [changePercentObj.differenceValue, "\u00A0(", changePercentObj.differencePercentage, ")"] }))] })) }));
    }, []);
    const handleCheckboxChange = (checked, index) => {
        // Get the current master array
        const masterArray = indicesMaster;
        // Update the checkbox state in the master array
        masterArray[index].checkbox = checked;
        // Check if the checkbox is checked
        if (checked) {
            // If the checkbox is checked, get the indices of all the checked checkboxes
            const checkedIndices = masterArray.filter((item) => item.checkbox === true);
            // If there are only two checked checkboxes, disable all the other checkboxes
            if (checkedIndices.length === 2) {
                masterArray.forEach((item, i) => {
                    if (!checkedIndices.includes(item)) {
                        item.disabled = true;
                    }
                });
            }
            setIndiceCheckedList(checkedIndices);
        }
        else {
            // If the checkbox is unchecked, enable all the checkboxes
            masterArray.forEach((item, i) => {
                item.disabled = false;
            });
            const checkedIndices = masterArray.filter((item) => item.checkbox === true);
            setIndiceCheckedList(checkedIndices);
        }
        // Set the new master array
        setIndicesMaster(masterArray);
    };
    const handleApplyIndices = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (indiceCheckedList.length === 2) {
                const lstofIndices = indiceCheckedList.map((item) => ({
                    IndexName: item.IndexName,
                    ScripCode: item.IndiceID,
                    Exch: item.Exch,
                    ExchType: item.ExchType,
                }));
                const response = yield setMasterIndices(lstofIndices);
                if (response.data.body.length > 0) {
                    updateIndexData();
                    setShowIndicesDD(false);
                }
            }
        }
        catch (err) {
            console.error(err);
        }
    });
    const commonLtpRenderCallBack = useCallback((scripCode, ltp, prevClose, changePercentObj) => {
        if (isEmpty(ltp)) {
            return _jsx(_Fragment, {});
        }
        indiceMapRef.current[scripCode] = { ltp, prevClose };
        return (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: `${styles.niftyLtp} ${changePercentObj.isNegative ? "negativeText" : "positiveText"}` }, { children: ltp })), _jsx("span", Object.assign({ className: `${styles.ltpChangeValue} ${changePercentObj.isNegative ? "negativeText" : "positiveText"} small` }, { children: changePercentObj.differenceValue })), _jsxs("span", Object.assign({ className: `${styles.ltpChangePercentage} ${changePercentObj.isNegative ? "negativeText" : "positiveText"} small` }, { children: ["(", changePercentObj.differencePercentage, ")"] })), _jsx("span", { className: `${changePercentObj.isNegative ? styles.redArrow : styles.greenArrow}` })] }));
    }, []);
    const onChartIconClick = (data) => {
        const nameBreakup = splitAndGetDetailsFromLongName(data.IndexName);
        const chartData = {
            fullName: data.IndexName,
            strikePrice: data.strikeRate,
            exchange: data.Exch,
            exchangeType: data.ExchType,
            expiry: nameBreakup.expiry || "",
            symbol: data.IndexName,
            scripCode: data.ScripCode,
        };
        openChartTab(chartData);
    };
    const renderSinlgeIndexData = (singleIndexData) => {
        return (_jsxs("div", Object.assign({ className: `${styles.marketIndicesList}` }, { children: [_jsx("span", Object.assign({ className: styles.indexTitleName, title: singleIndexData.IndexName.toUpperCase(), onDoubleClick: () => stockInfoPage(singleIndexData, "") }, { children: singleIndexData.IndexName.toUpperCase() })), _jsx(CommonLtpRenderer, { scripCode: singleIndexData.ScripCode, exch: singleIndexData.Exch, exchType: singleIndexData.ExchType, renderElement: (ltp, prevClose, changePercentObj) => {
                        return commonLtpRenderCallBack(singleIndexData.ScripCode, ltp, prevClose, changePercentObj);
                    }, componentName: componentName })] }), singleIndexData.IndexName));
    };
    return _jsx(_Fragment, { children: renderIndexData() });
};
export default IndicesBar;
